













































































































































































































import { Vue, Component } from 'vue-property-decorator';
import PageHeader from 'components/layout/Header.vue';
import PageFooter from 'components/layout/Footer.vue';
import axios from '@/services/axios';
import wx from 'weixin-sdk-js';
import { Action, Getter } from 'vuex-class';
import { UserInfo } from '@/types/root';

interface course {
  id: number;
  course: string;
  courseDetail?: string;
}
declare const window: any;

@Component({
  components: {
    PageHeader,
    PageFooter
  }
})
export default class App extends Vue {
  public ERCodeLocation: string = `url(//game.weixin.qq.com/cgi-bin/comm/qrcode?s=10&m=1&d=${encodeURIComponent(
    window.location.href
  )})`;
  @Action('getUserInfo') private getUserInfo!: Function;
  @Action('setUserInfo') private setUserInfo!: Function;

  private _validateLoginState(): void {
    const autoLogin: string | null = window.localStorage.getItem('autoLogin');
    if (autoLogin === 'true') {
      window.localStorage.removeItem('autoLogin');
      this.getUserInfo();
    } else {
      let userInfo: string | null = window.localStorage.getItem('mobileUserInfo');
      if (userInfo) {
        try {
          let user = JSON.parse(userInfo);
          this.setUserInfo(user);
        } catch (error) {
          alert({ message: '用户信息解析错误，请稍后重试' });
        }
      }
    }
  }

  private visibleLayerIntroduce: boolean = false;
  private courseList: Array<course> = [
    {
      id: 1,
      course: '游戏运营发行与行业发展',
      courseDetail:
        '通过该课程帮助学生了解游戏发行运营的主要工作内容，能力要求和发展内容，对游戏发行运营有一定的了解和理解。其中的项目案例和行业游戏公司介绍也会辅助学生加深职业概念。'
    },
    {
      id: 2,
      course: '游戏新产品评估以及引进体系',
      courseDetail:
        '课程将带大家初步认识腾讯游戏的新产品评估以及引进体系，学会从市场、用户、开发商以及游戏本身的角度出发分析，掌握产品评测的重要纬度并懂得结合其他重要因素全局看待问题，让玩游戏变的有意义。'
    },
    {
      id: 3,
      course: '游戏本地化设计',
      courseDetail:
        '本课程通过行业历程及具体经典案例，首先介绍本地化的基本定义和岗位价值，再从宏观的文化、审美、玩法偏好等方面分析本地化工作的内容和能力要求，最后再结合实际工作讲解本地化常用的研究方法。'
    },
    {
      id: 4,
      course: '游戏商业化运营',
      courseDetail:
        '学生将通过本课程了解游戏商业化运营基础概念及背后常用经济学、心理学知识，初步掌握用户分层方法以及商业化内容设计方法。'
    },
    {
      id: 5,
      course: '游戏数据运营',
      courseDetail: '介绍游戏运营数据和数据分析的价值，常用方法与工具，以及在游戏项目运营中各个模块的应用与实战。'
    },
    {
      id: 6,
      course: '游戏社区运营',
      courseDetail:
        '本课程将从从业者的角度，为大家解析社区运营在游戏运营中的作用。通过课程学习，可以初步了解社区运营如何凝聚玩家，实现对用户游戏行为的干预。'
    },
    {
      id: 7,
      course: '电子竞技与赛事运营',
      courseDetail:
        '本课程将带领大家了解电子竞技在中国的发展史，了解电子竞技运营岗位的工作方式，并通过案例掌握电竞各个模块的实战经验。'
    },
    {
      id: 8,
      course: '从CF到CFM，谈FPS游戏的长青之路',
      courseDetail:
        '课程从长线游戏设计和长线游戏运营两个角度切入，分享了CF系列产品保持长青的原因。CF系列保持长青的关键原因在于由爆款思维到长线思维、从游戏打造到情怀打造等研发运营思路上的转变与升级。'
    },
    {
      id: 9,
      course: '结业考核'
    }
  ];
  private courseDetail: course = this.courseList[0];

  showLayerIntroduce(obj: course): void {
    this.courseDetail = obj;
    this.visibleLayerIntroduce = true;
  }

  mounted(): void {
    this._validateLoginState();
    axios.get(`/mobile/weixin/config?url=${encodeURIComponent(window.location.href)}`).then(res => {
      wx.config(res.data);
      wx.ready(() => {
        const shareData = {
          title: '2020腾讯游戏运营公开课',
          desc: '学员招募火热开启，pick热爱游戏的你！',
          imgUrl: 'https://tig.qpic.cn/m/share/activity/producer2020-share.jpg',
          link: `${window.location.origin}${window.location.pathname}`,
          success: () => {
            /* global MtaH5 */
            window.MtaH5.clickStat('game_operation_2020');
          }
        };
        wx.onMenuShareTimeline(shareData);
        wx.onMenuShareAppMessage(shareData);
      });
    });
  }
}
